var map = {
	"./check-inactive.svg": "pqHt",
	"./check.svg": "G/IM",
	"./corporate/driver.svg": "L2Zn",
	"./corporate/hak-akses-pengguna.svg": "5uDc",
	"./corporate/payment-channel.svg": "emfM",
	"./corporate/pengguna.svg": "sWpC",
	"./corporate/pic-corporate.svg": "G9LM",
	"./corporate/profile.svg": "iu7b",
	"./corporate/sales-setting.svg": "w0s5",
	"./corporate/unit-produksi.svg": "8bIL",
	"./corporate/warehouse.svg": "yOsz",
	"./customer.svg": "3Lkx",
	"./dashboard-inactive.svg": "FH39",
	"./dashboard.svg": "wyEq",
	"./delete_fuel-index-red.svg": "bbcC",
	"./delete_sampah/bpjs.svg": "bD/x",
	"./delete_sampah/dashboard.svg": "1YNg",
	"./delete_sampah/event.svg": "pGaZ",
	"./delete_sampah/koperasi.svg": "gczC",
	"./delete_sampah/master.svg": "oq07",
	"./delete_sampah/myaction.svg": "NXdQ",
	"./delete_sampah/payroll.svg": "zlBl",
	"./delete_sampah/pengaturan-pengguna.svg": "6GP/",
	"./delete_sampah/pengelolaan.svg": "851A",
	"./delete_sampah/perusahaan.svg": "40Cf",
	"./delete_sampah/presensi.svg": "sa07",
	"./delete_sampah/rekrutmen.svg": "MI4G",
	"./delete_sampah/reload-module.svg": "3XKP",
	"./delete_sampah/setting.svg": "qVHq",
	"./equipment/batching-plant.svg": "zXw8",
	"./equipment/genset.svg": "8Bgp",
	"./equipment/loader.svg": "vvt1",
	"./equipment/setting.svg": "fBkY",
	"./equipment/truck-mixer.svg": "Zh5K",
	"./equipment/tyre-opname.svg": "tc7+",
	"./equipment/tyre-usage.svg": "DVOq",
	"./equipment/tyre.svg": "b7V3",
	"./fuel-index.svg": "Oh0Y",
	"./inventory-inactive.svg": "uVS7",
	"./inventory.svg": "VzA2",
	"./inventory/bahan-masuk.svg": "pwSp",
	"./inventory/batching-plant.svg": "RnP1",
	"./inventory/data-material.svg": "eb3s",
	"./inventory/data-vendor.svg": "1Yq1",
	"./inventory/fuel-index.svg": "Mwt7",
	"./inventory/fuel-suage.svg": "OOQ6",
	"./inventory/material-stock.svg": "Z/NB",
	"./inventory/material-transfer.svg": "rc4x",
	"./inventory/material-usage.svg": "nHOd",
	"./inventory/purchase-order.svg": "RSiW",
	"./inventory/report.svg": "5jQT",
	"./inventory/stock-opname.svg": "AljC",
	"./maintenance-inactive.svg": "LW5M",
	"./maintenance.svg": "7ZpI",
	"./master-inactive.svg": "OK57",
	"./master.svg": "ifFT",
	"./money.svg": "Z/px",
	"./myaction.svg": "F+GE",
	"./notification.svg": "mp8J",
	"./pembayaran.svg": "xB+m",
	"./produksi-inactive.svg": "EbfO",
	"./produksi.svg": "5sjv",
	"./produksi/data-produk.svg": "NNz3",
	"./produksi/jadwal-produksi.svg": "P/iv",
	"./produksi/kategori-produk.svg": "2meJ",
	"./produksi/realisasi-produksi.svg": "5p/Q",
	"./produksi/rework.svg": "FvrE",
	"./profil.svg": "Rhxa",
	"./prospek-sales.svg": "Ikuz",
	"./quality/indikator-quality.svg": "NR/f",
	"./quality/konfigurasi-quality.svg": "jqqJ",
	"./quality/report-quality.svg": "790F",
	"./report-inactive.svg": "3xRu",
	"./report-inactives.svg": "k4i2",
	"./report.svg": "bq+k",
	"./report/clipboard.svg": "Mg5H",
	"./report/maintenance-inactive.svg": "Fnjh",
	"./report/report.svg": "rqYy",
	"./sales-inactive.svg": "asuP",
	"./sales-order.svg": "SsVE",
	"./sales-setting.svg": "0SRN",
	"./sales.svg": "kZSf",
	"./sales/casting.svg": "Dvzw",
	"./sales/menu.svg": "W7Bs",
	"./sales/pembayaran.svg": "TB+d",
	"./sales/prospek-sales.svg": "8MQu",
	"./sales/report.svg": "y8kA",
	"./sales/sales-order.svg": "hyc+",
	"./sales/setting.svg": "z4yl",
	"./sales/user.svg": "mXQb",
	"./setting-inactive.svg": "hoj9",
	"./setting.svg": "fRIR",
	"./so.svg": "cTBr",
	"./superadmin-inactive.svg": "sPaU",
	"./under-maintenance.svg": "Eaml"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "z6BW";


//////////////////
// WEBPACK FOOTER
// ./static/img/icon ^\.\/.*\.svg$
// module id = z6BW
// module chunks = 201